export default "__VITE_ASSET__DiXpWqRQ__"